export const cleanArray = (array: any[]) => {
  return array.filter((item) => item !== undefined && item !== null)
}
